export default __webpack_public_path__ + "static/media/5.84f584c9.png";